import {ListItemIcon, css, styled} from '@mui/material';
import {StyledProps} from './types';

const StyledListItemIcon = styled(ListItemIcon)<StyledProps>`
	min-width: initial;
	margin-right: 8px;
	color: ${({theme}) => theme.palette.primary.main};

	${({$removeIconMargin}) =>
		$removeIconMargin &&
		css`
			margin-right: 0px;
		`}

	${({$removeItemTextMargin}) =>
		$removeItemTextMargin &&
		css`
			margin-top: 0px;
		`}
`;
export {StyledListItemIcon};
